export const translations = {
  it: {
    nav: {
      about: "Chi Siamo",
      menu: "Menù",
      highlights: "Perché Noi",
      contacts: "Contatti",
      cta: "Prenota un Tavolo",
      openMenu: "Apri il menu",
      closeMenu: "Chiudi il menu",
    },
    hero: {
      eyebrow: "Enoteca · Wine Bar · Cefalù",
      titleA: "La Cantina",
      titleB: "del Barone",
      subtitle: "Eccellenza Enogastronomica nel Cuore di Cefalù",
      ctaMenu: "Scopri il Menù",
      ctaBooking: "Prenota un Tavolo",
      cardTitle: "Al banco e nel dehors",
      cardLines: ["Vini siciliani al calice", "Taglieri di prodotti tipici", "Birre artigianali & liquori"],
      scroll: "Scorri",
    },
    marquee: [
      "Etna DOC",
      "Nero d'Avola",
      "Salumi dei Nebrodi",
      "Formaggi delle Madonie",
      "Birre Artigianali",
      "Passito di Pantelleria",
      "Cefalù · Centro Storico",
    ],
    about: {
      chapter: "Capitolo 01",
      title: "La nostra storia",
      p1: "Nel tessuto di vicoli in pietra del centro storico di Cefalù, La Cantina del Barone è una tappa per chi cerca la Sicilia autentica: un calice offerto con cura, un tagliere generoso, il piacere lento della conversazione.",
      p2: "Selezione di vini etnei e Doc dell'isola, birre artigianali di piccoli birrifici, liquori e prodotti tipici di eccellenza: tutto è scelto da chi ama raccontare il territorio, bicchiere dopo bicchiere.",
      quote: "«Ogni bottiglia racconta un territorio, ogni tagliere una tradizione.»",
      badge: "Centro Storico · Cefalù",
    },
    menu: {
      chapter: "Capitolo 02",
      title: "Il Menù",
      subtitle: "Una selezione che cambia con le stagioni e con le grazia dei nostri fornitori siciliani.",
      search: "Cerca un vino, un tagliere…",
      tabs: { vini: "Selezione Vini", taglieri: "Taglieri & Prodotti Tipici", birre: "Birre Artigianali & Liquori" },
      sub: { tutti: "Tutti", rossi: "Rossi", bianchi: "Bianchi", bollicine: "Bollicine", dolci: "Dolci" },
      glass: "Calice",
      bottle: "Bottiglia",
      loading: "Stiramiamo il menù…",
      error: "Il menù non si carica al momento.",
      retry: "Riprova",
      empty: "Nessun risultato per la tua ricerca.",
      emptyHint: "Prova con un altro nome o cancella la ricerca.",
    },
    highlights: {
      chapter: "Capitolo 03",
      title: "Perché ci scegliono",
      items: [
        {
          num: "01",
          title: "Dehors sulle vie storiche",
          text: "Tavoli all'aperto tra i vicoli di pietra del centro storico: l'aperitivo con l'atmosfera della Cefalù antica.",
        },
        {
          num: "02",
          title: "A due passi dal mare",
          text: "Vicinissimi alla spiaggia e al porto: il tramonto sul mare si gusta meglio con un calice in mano.",
        },
        {
          num: "03",
          title: "Abbinamenti curati",
          text: "Ti guidiamo tra vini etnei e Doc siciliani, abbinati a salumi dei Nebrodi e formaggi delle Madonie.",
        },
      ],
    },
    booking: {
      title: "Prenota un Tavolo",
      subtitle: "Raccontaci come vuoi vivere la cantina: ti ricontatteriamo appena per confermare.",
      note: "La richiesta non è una conferma istantanea: il locale risponde via telefono o email, così niente sorprese da overbooking.",
      fields: {
        name: "Nome e cognome",
        email: "Email",
        phone: "Telefono",
        date: "Data",
        time: "Orario",
        guests: "Ospiti",
        experience: "Tipo di esperienza",
        notes: "Note (opzionali)",
      },
      experience: {
        aperitivo: "Aperitivo con tagliere",
        degustazione: "Degustazione di vini",
        cena: "Cena informale",
        calice: "Un calice al banco",
      },
      guestsSuffix: "persone",
      gdpr: "Acconsento al trattamento dei miei dati per gestire la richiesta di prenotazione (GDPR).",
      submit: "Invia Richiesta",
      submitting: "Invio…",
      successTitle: "Richiesta inviata!",
      successText: "Abbiamo ricevuto la tua richiesta: controlla la tua email e attendi la nostra conferma via telefono o email.",
      again: "Fai un'altra richiesta",
      errGeneric: "Qualcosa è andato storto. Riprova o chiamaci direttamente.",
      errRate: "Troppe richieste da questa connessione. Riprova tra un'ora o chiamaci.",
      errConsent: "Serve il consenso privacy per procedere.",
      errRequired: "Compila tutti i campi obbligatori.",
      call: "Chiama ora",
      whatsapp: "WhatsApp diretto",
    },
    contact: {
      title: "Vieni a trovarci",
      subtitle: "Siamo nel centro storico di Cefalù: scorri tra i vicoli e seguisci il profumo del vino buono.",
      addressLabel: "Indirizzo",
      address: "Centro Storico · Cefalù (PA)",
      phoneLabel: "Telefono",
      whatsapp: "Scrivici su WhatsApp",
      emailLabel: "Email",
      siteLabel: "Sito web",
      mapFallback: "Se la mappa non si carica: siamo nel centro storico di Cefalù (PA), chiedi di noi in paese.",
      mapTitle: "Mappa — La Cantina del Barone, Cefalù",
    },
    footer: {
      tagline: "Eccellenza enogastronomica nel cuore di Cefalù.",
      anchors: "Esplora",
      contacts: "Recapiti",
      legal: "L'abuso di alcolici è nocivo per la salute. Vietata la vendita a minori di 18 anni.",
      rights: "Tutti i diritti riservati.",
    },
    admin: {
      title: "Pannello Richieste",
      password: "Password admin",
      login: "Accedi",
      wrong: "Password errata.",
      filterAll: "Tutte",
      counts: { new: "Nuove", confirmed: "Confermate", declined: "Rifiutate", total: "Totali" },
      empty: "Nessuna richiesta in questa categoria.",
      confirm: "Conferma",
      decline: "Rifiuta",
      reset: "Reimposta",
      logout: "Esci",
      loading: "Caricamento…",
      errLoad: "Errore nel caricamento delle richieste.",
    },
  },
  en: {
    nav: {
      about: "About Us",
      menu: "Menu",
      highlights: "Why Us",
      contacts: "Contacts",
      cta: "Book a Table",
      openMenu: "Open menu",
      closeMenu: "Close menu",
    },
    hero: {
      eyebrow: "Enoteca · Wine Bar · Cefalù",
      titleA: "La Cantina",
      titleB: "del Barone",
      subtitle: "Gastronomic Excellence in the Heart of Cefalù",
      ctaMenu: "Discover the Menu",
      ctaBooking: "Book a Table",
      cardTitle: "At the counter & on the terrace",
      cardLines: ["Sicilian wines by the glass", "Platters of local specialities", "Craft beers & liqueurs"],
      scroll: "Scroll",
    },
    marquee: [
      "Etna DOC",
      "Nero d'Avola",
      "Nebrodi cured meats",
      "Madonie cheeses",
      "Craft beers",
      "Passito di Pantelleria",
      "Cefalù · Old Town",
    ],
    about: {
      chapter: "Chapter 01",
      title: "Our story",
      p1: "In the web of stone alleys in Cefalù's old town, La Cantina del Barone is a stop for anyone looking for authentic Sicily: a carefully poured glass, a generous platter, the slow pleasure of conversation.",
      p2: "A selection of Etna and island Doc wines, craft beers from small breweries, liqueurs and exceptional local produce: everything is chosen by people who love telling the story of this land, glass after glass.",
      quote: "\u201CEvery bottle tells of a territory, every platter of a tradition.\u201D",
      badge: "Old Town · Cefalù",
    },
    menu: {
      chapter: "Chapter 02",
      title: "The Menu",
      subtitle: "A selection that changes with the seasons and with the bounty of our Sicilian suppliers.",
      search: "Search a wine, a platter…",
      tabs: { vini: "Wine Selection", taglieri: "Platters & Local Produce", birre: "Craft Beers & Liqueurs" },
      sub: { tutti: "All", rossi: "Reds", bianchi: "Whites", bollicine: "Sparkling", dolci: "Dessert" },
      glass: "Glass",
      bottle: "Bottle",
      loading: "Uncorking the menu…",
      error: "The menu isn't loading right now.",
      retry: "Try again",
      empty: "No results for your search.",
      emptyHint: "Try another name or clear the search.",
    },
    highlights: {
      chapter: "Chapter 03",
      title: "Why people choose us",
      items: [
        {
          num: "01",
          title: "Terrace on the historic streets",
          text: "Outdoor tables among the stone alleys of the old town: aperitivo with the atmosphere of ancient Cefalù.",
        },
        {
          num: "02",
          title: "Steps away from the sea",
          text: "Moments from the beach and the harbour: sunset over the sea tastes better with a glass in hand.",
        },
        {
          num: "03",
          title: "Curated pairings",
          text: "We guide you through Etna and Sicilian Doc wines, paired with Nebrodi cured meats and Madonie cheeses.",
        },
      ],
    },
    booking: {
      title: "Book a Table",
      subtitle: "Tell us how you'd like to enjoy the cantina: we'll get back to you shortly to confirm.",
      note: "A request is not an instant confirmation: the venue replies by phone or email, so there are no overbooking surprises.",
      fields: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        date: "Date",
        time: "Time",
        guests: "Guests",
        experience: "Type of experience",
        notes: "Notes (optional)",
      },
      experience: {
        aperitivo: "Aperitif with platter",
        degustazione: "Wine tasting",
        cena: "Informal dinner",
        calice: "A glass at the counter",
      },
      guestsSuffix: "people",
      gdpr: "I consent to my data being processed to handle this booking request (GDPR).",
      submit: "Send Request",
      submitting: "Sending…",
      successTitle: "Request sent!",
      successText: "We've received your request: check your email and wait for our confirmation by phone or email.",
      again: "Make another request",
      errGeneric: "Something went wrong. Try again or call us directly.",
      errRate: "Too many requests from this connection. Try again in an hour or call us.",
      errConsent: "We need your privacy consent to proceed.",
      errRequired: "Please fill in all required fields.",
      call: "Call now",
      whatsapp: "Direct WhatsApp",
    },
    contact: {
      title: "Come and visit us",
      subtitle: "We're in Cefalù's old town: wander through the alleys and follow the scent of good wine.",
      addressLabel: "Address",
      address: "Old Town · Cefalù (PA), Italy",
      phoneLabel: "Phone",
      whatsapp: "Message us on WhatsApp",
      emailLabel: "Email",
      siteLabel: "Website",
      mapFallback: "If the map doesn't load: we're in the old town of Cefalù (PA), just ask for us in town.",
      mapTitle: "Map — La Cantina del Barone, Cefalù",
    },
    footer: {
      tagline: "Gastronomic excellence in the heart of Cefalù.",
      anchors: "Explore",
      contacts: "Contacts",
      legal: "Alcohol abuse is harmful to health. Sale to under-18s is prohibited.",
      rights: "All rights reserved.",
    },
    admin: {
      title: "Request Panel",
      password: "Admin password",
      login: "Sign in",
      wrong: "Wrong password.",
      filterAll: "All",
      counts: { new: "New", confirmed: "Confirmed", declined: "Declined", total: "Total" },
      empty: "No requests in this category.",
      confirm: "Confirm",
      decline: "Decline",
      reset: "Reset",
      logout: "Sign out",
      loading: "Loading…",
      errLoad: "Failed to load requests.",
    },
  },
};
